// about-us.js
import React from 'react';
import HandPos from '../assets/images/vernposhand.png';
import WhyChoose from '../components/WhyChoose';
import ContactCTA from '../components/ContactCTA';
// import SEO from '../components/SEO';
// import WomanWhite from '../assets/images/womanwhite.png';

const AboutUs = () => {
  // const testimonials = [
  //   {
  //     id: 1,
  //     name: 'Sarah, Café Owner',
  //     quote: 'VernPOS transformed our operations overnight!',
  //     image: '/api/placeholder/100/100',
  //   }
  // ];

  const benefits = [
    {
      id: 1,
      title: 'Reduce Labor Costs',
      description: 'Automating the ordering process lets you focus your staff on higher-value tasks like customer service and food preparation.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-8 h-8 text-vern">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
    },
    {
      id: 2,
      title: 'Increase Sales with Upsells',
      description: 'The kiosk suggests upsells and add-ons during the ordering process, increasing average ticket size.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-8 h-8 text-vern">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      ),
    },
    {
      id: 3,
      title: 'Faster Turnaround',
      description: 'With the kiosk, orders are placed faster and more accurately, improving the overall customer experience.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-8 h-8 text-vern">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
    {
      id: 4,
      title: 'Better Customer Flow',
      description: 'Reduce long lines and wait times, especially during peak hours, keeping your operation smooth and efficient',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-8 h-8 text-vern">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
  ];

  return (
    <>
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Hero Section */}
        <section className="mt-16 mb-16 text-center">
          <p className="text-gray-600 mb-2">Streamline Your Operations. Delight Your Customers. Grow Your Business</p>
          <h1 className="text-4xl font-bold mb-8">VernPOS: Elevate Your F&B Experience with the Future of Point-of-Sale</h1>

          <div className="max-w-3xl mx-auto text-left">
            <p className="text-lg text-center mb-8">
              At VernPOS, we know that running an F&B business is more than just serving great food—it's about providing an exceptional experience from start to finish.
              Our powerful, all-in-one POS system is designed to simplify your operations, leaving you more time to focus on what matters most: your customers.
            </p>
          </div>

          <div className="rounded-lg overflow-hidden shadow-lg">
            <img
              src={HandPos}
              alt="VernPOS System in action"
              className="w-full"
            />
          </div>
        </section>

        <WhyChoose
          heading='Why Choose VernPOS: Benefits That Boost Your Business'
          subheading='Experience a smarter, faster, and more efficient way to manage your business with VernPOS. From seamless transactions to real-time insights, our POS solutions are built to help you grow.'
          benefits={benefits}
        />

        {/* CTA Banner */}
        <ContactCTA />

        {/* Testimonials */}
        {/* <section className="mb-16">
        <h2 className="text-3xl font-bold mb-8 text-center">Unlock the Full Potential of Your Business</h2>
        <p className="text-gray-600 text-center mb-8">
          Discover how VernPOS can drive efficiency, reduce costs, and grow your bottom line.
        </p>
        
        <div className="bg-vern rounded-xl overflow-hidden shadow-lg">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="p-8">
              <div className="flex items-center flex-col md:flex-row">
                <div className="mb-4 md:mb-0 md:mr-6">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name} 
                    className="w-16 h-16 object-cover rounded-full"
                  />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">VernPOS transformed our operations overnight!</h3>
                  <p className="text-gray-700 mb-2">We've reduced wait times and improved order accuracy. Our customers love it!</p>
                  <p className="font-medium">— {testimonial.name}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section> */}
      </div>
    </>
  );
};

export default AboutUs;